module.exports = __webpack_public_path__ + "img/mh.f21ef411.svg";